






















































































































import {Component, Model, Prop, Vue, Watch} from 'vue-property-decorator'

@Component
export default class DialogNewBoletoEspecialSolicitado extends Vue {
  @Prop() private msg!: string
  @Model('model', { type: Object })
  private model!: object

  private name: string = 'DialogNewBoleto'

  private mModel: object = {
    precio: 10,
    folioIni: '',
    folioFin: '',
    name: '',
    status: 0,
    boletos: {}
  }
  private dialog: boolean = false
  private action: string = 'new'
  private titleNew: string = 'Agregar Boleto'
  private titleMod: string = 'Modificar Boleto'

  private beforeMount () {
    console.log('beforeMount :: ', this.name)
    if (typeof this.model === 'object') this.mModel = this.model
  }

  @Watch('model')
  private watchModel (v: any) {
    if (typeof v === 'object') {
      this.mModel = v
      this.action = 'edit'
      this.dialog = true
    }
  }

  @Watch('dialog')
  private watchDialog (v: any) {
    if (!v) {
      this.mModel = {
        precio: 10.00,
        folioIni: '',
        folioFin: '',
        name: '',
        status: 0
      }
    }
  }
}
